module.exports = __webpack_public_path__ + "img/headImgWoman.f2fe6645.png";